export const stringIncludes = (str?: string, search?: string): boolean => {
  if (!str || !search) {
    return false;
  }
  return str.toLowerCase().includes(search.toLowerCase());
};

export const isMongoObjectId = (id: string) => /^[a-f0-9]{24}$/i.test(id);
